import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";

import { Avatar, AvatarImage, AvatarFallback } from "../ui/avatar";
import { Button } from "../ui/button";

import { AuthContext } from "../../context/Auth/AuthContext";
import toastError from "../../errors/toastError";
import api from "../../services/api";

const VcardPreview = ({ contact, numbers }) => {
	const navigate = useNavigate();
	const { user } = useContext(AuthContext);

	const [selectedContact, setContact] = useState({
		name: "",
		number: "",
		profilePicUrl: "",
	});

	useEffect(() => {
		const debounce = setTimeout(() => {
			const buscarContato = async () => {
				try {
					const payload = {
						name: contact,
						number: numbers !== undefined ? numbers.replace(/\D/g, "") : "",
						email: "",
					};
					// A rota é /contacts (plural); "/contact" devolvia 404.
					const { data } = await api.post("/contacts", payload);
					setContact(data);
				} catch (err) {
					toastError(err);
				}
			};
			buscarContato();
		}, 500);

		return () => clearTimeout(debounce);
	}, [contact, numbers]);

	const abrirConversa = async () => {
		try {
			const { data: ticket } = await api.post("/tickets", {
				contactId: selectedContact.id,
				userId: user.id,
				status: "open",
			});
			navigate(`/tickets/${ticket.id}`);
		} catch (err) {
			toastError(err);
		}
	};

	const iniciais = (selectedContact.name || contact || "?")
		.split(" ")
		.slice(0, 2)
		.map((parte) => parte[0])
		.join("")
		.toUpperCase();

	return (
		<div className="w-[250px] overflow-hidden rounded-lg border bg-card">
			<div className="flex items-center gap-2.5 p-3">
				<Avatar className="h-10 w-10 shrink-0">
					<AvatarImage
						src={selectedContact.profilePicUrl}
						alt={selectedContact.name}
					/>
					<AvatarFallback>{iniciais}</AvatarFallback>
				</Avatar>
				<div className="min-w-0">
					<p className="truncate text-sm font-medium">
						{selectedContact.name || contact}
					</p>
					{selectedContact.number && (
						<p className="truncate text-xs tabular-nums text-muted-foreground">
							{selectedContact.number}
						</p>
					)}
				</div>
			</div>

			<div className="border-t">
				<Button
					variant="ghost"
					className="w-full rounded-none"
					onClick={abrirConversa}
					disabled={!selectedContact.number}
				>
					Conversar
				</Button>
			</div>
		</div>
	);
};

export default VcardPreview;
